// Finance ledger queries and mutations (slice 2a). Every mutation refreshes all finance data and toasts.
// They settle on the server's answer, so a modal closes on the 200 while the lists refresh behind it.
import { useQuery } from "@tanstack/react-query";
import { ledgerService } from "../services/ledgerService";
import type { FreelancerInput } from "../types";
import { addedToast } from "../utils/people";
import { financeKeys, useFinanceMutation } from "./financeQuery";

export const ledgerKeys = {
  people: () => [...financeKeys.all, "people"] as const,
  ownClient: () => [...financeKeys.all, "own-client"] as const,
};

/** The agency's own client (TD-105), or none. */
export const useOwnClient = (enabled = true) => useQuery({ queryKey: ledgerKeys.ownClient(), queryFn: ledgerService.ownClient, enabled });

/** Names the agency's own client, or clears it with null (TD-105). Its open jobs and ad spend rebook, so every finance
 * list refetches. */
export const useSetOwnClient = () =>
  useFinanceMutation(
    (clientId: string | null) => ledgerService.setOwnClient(clientId),
    (state) => (state.clientName ? `${state.clientName} is the agency's own profile now.` : "The agency's own profile is turned off."),
    // A refusal (a client already invoiced) shows in the drawer's footer, never also as a toast.
    { refusedInline: true },
  );

export const usePeople = () => useQuery({ queryKey: ledgerKeys.people(), queryFn: ledgerService.people });

/** Adds a freelancer outside the team (TD-106). Every finance list refetches, so the Team tab and the pickers list them. */
export const useAddFreelancer = () => useFinanceMutation((input: FreelancerInput) => ledgerService.addPerson(input), addedToast);
